import { ASSETS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/assets_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

// Dedicated target collection for sub-asset fetches across the app (Sub Assets
// tab, WO creation/edit forms). Keeps these reads from overwriting the default
// `state.assets.recordsIds` / pagination that other pages depend on.
export const SUB_ASSETS_TARGET_COLLECTION = 'subAssetsFetch';

const initialState: any = standardInitialStateGenerator([
	'assetsIndex',
	'WORK_ORDER_FORM_ASSETS_AUTOCOMPLETE',
	'SUPPLIER_WORK_ORDER_FORM_ASSETS_AUTOCOMPLETE',
	'SERVICE_REQUEST_FORM_ASSETS_AUTOCOMPLETE',
	'locationAssociatedAssets',
	'PLANNED_MAINTENANCE_SCHEDULE_FORM_ASSETS_AUTOCOMPLETE',
	'METER_FORM_ASSETS_AUTOCOMPLETE',
	'plannedMaintenanceAdvancedFilters',
	'assetsDowntime',
	'readyForReplacement',
	'troubleshootingFormIndex',
	'purchaseOrderReceivedAssets',
	'invoicesAdvancedFilters',
	'bulkEditAssets',
	'workOrdersAdvancedFilters',
	'invoicesAdvancedFilters',
	'quotesAdvancedFilters',
	SUB_ASSETS_TARGET_COLLECTION,
]);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
